/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Local_PickupInputs */

const en_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local Pickup`)
};

const es_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recogida local`)
};

const fr_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrait sur place`)
};

const de_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokale Abholung`)
};

const ja_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`店頭受け取り`)
};

const zh_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本地自提`)
};

const ar_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استلام محلي`)
};

const id_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengambilan Lokal`)
};

const it_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritiro in Zona`)
};

const ru_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самовывоз`)
};

const pt_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirada no Local`)
};

const ko_fulfillment_local_pickup = /** @type {(inputs: Fulfillment_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방문 수령`)
};

/**
* | output |
* | --- |
* | "Local Pickup" |
*
* @param {Fulfillment_Local_PickupInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_local_pickup = /** @type {((inputs?: Fulfillment_Local_PickupInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Local_PickupInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_local_pickup(inputs)
	if (locale === "es") return es_fulfillment_local_pickup(inputs)
	if (locale === "fr") return fr_fulfillment_local_pickup(inputs)
	if (locale === "de") return de_fulfillment_local_pickup(inputs)
	if (locale === "ja") return ja_fulfillment_local_pickup(inputs)
	if (locale === "zh") return zh_fulfillment_local_pickup(inputs)
	if (locale === "ar") return ar_fulfillment_local_pickup(inputs)
	if (locale === "id") return id_fulfillment_local_pickup(inputs)
	if (locale === "it") return it_fulfillment_local_pickup(inputs)
	if (locale === "ru") return ru_fulfillment_local_pickup(inputs)
	if (locale === "pt") return pt_fulfillment_local_pickup(inputs)
	return ko_fulfillment_local_pickup(inputs)
});